import React from 'react';
import { Alert } from 'react-bootstrap';

const AllUserList = () => {
    return (
        <div>
            <h1 className="font-weight-bold text-center my-2">All User List</h1>
            <Alert variant="success">Coming soon</Alert>
        </div>
    );
};

export default AllUserList;